var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{attrs:{"id":"code"}},[_c('code',[_c('pre',{domProps:{"innerHTML":_vm._s(_vm.highlightedCode)}})])])])}
var staticRenderFns = []

export { render, staticRenderFns }